import { IPublishedApi } from '../constants/apiList.interface';
import { createSlice } from '@reduxjs/toolkit';

interface IApiListState {
  showConfirmUnpublishModal: boolean;
  showApiDetailsModal: boolean;
  selectedApiDetails: IPublishedApi | null;
  isPublished: boolean;
  isPublic: boolean;
}

export const apiListInitialState: IApiListState = {
  showConfirmUnpublishModal: false,
  showApiDetailsModal: false,
  selectedApiDetails: null,
  isPublished: false,
  isPublic: false,
};

export const apiListReducer = {
  resetState: (state: IApiListState) => {
    state.showConfirmUnpublishModal = apiListInitialState.showConfirmUnpublishModal;
    state.showApiDetailsModal = apiListInitialState.showApiDetailsModal;
    state.selectedApiDetails = apiListInitialState.selectedApiDetails;
    state.isPublished = apiListInitialState.isPublished;
    state.isPublic = apiListInitialState.isPublic;
  },

  openApiDetailsModal: (state: IApiListState, action: { payload: IPublishedApi }) => {
    state.showApiDetailsModal = true;
    state.selectedApiDetails = action.payload;
    state.isPublished = action.payload.published;
    state.isPublic = action.payload.apiKey === 'public';
  },

  closeApiDetailsModal: (state: IApiListState) => {
    state.showApiDetailsModal = false;
    state.selectedApiDetails = null;
  },

  openConfirmUnpublishModal: (state: IApiListState) => {
    state.showConfirmUnpublishModal = true;
  },

  closeConfirmUnpublishModal: (state: IApiListState) => {
    state.showConfirmUnpublishModal = false;
  },
};

export const apiListSlice = createSlice({
  name: 'apiList',
  initialState: apiListInitialState,
  reducers: apiListReducer,
});

export const {
  resetState,
  openApiDetailsModal,
  closeApiDetailsModal,
  openConfirmUnpublishModal,
  closeConfirmUnpublishModal,
} = apiListSlice.actions;

export default apiListSlice.reducer;
